// extracted by css-extract-rspack-plugin
export default {"modal":"rXHNjG","form":"US9bGN","body":"hIen4g","heading":"EOjtVq","options":"DQzpW_","actions":"VkuRFw"};